import { RootState } from '@iwProvider/configureStore';
import { Stripe } from '@stripe/stripe-js';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { StripeLinkDebitCardForm } from './StripeLinkDebitCardForm';
import IwStripeProvider from '../../../iwStripeProvider/IwStripeProvider';
import { getStripePublicKey } from '../../../iwStripeProvider/StripeHelper';
import { REGISTER_DEBIT_CARD } from '../../modals/addPaymentMethodModal/AddPaymentMethodModal.actions';
import { PaymentMethodAuthenticationModal } from '../../modals/paymentMethodAuthenticationModal/PaymentMethodAuthenticationModal';
import styles from '../LinkDebitCard.module.css';

const mapStateToProps = ({
    addPaymentMethodModal
}: {
    addPaymentMethodModal: RootState['addPaymentMethodModal'];
}) => addPaymentMethodModal;

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onSuccess: (
        stripe: Stripe,
        repaymentRole: string | null,
        billingPostcode: string,
        cardholderName: string
    ) =>
        dispatch({
            type: REGISTER_DEBIT_CARD,
            stripe,
            repaymentRole,
            billingPostcode,
            cardholderName
        })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

const StripeLinkDebitCardBase = ({
    requiresAuthentication,
    authenticationIframeURL,
    authenticationFailed,
    onSuccess,
    showDefaultPaymentMethodCheckbox = false,
    useSectionGridLayout = false
}: {
    showDefaultPaymentMethodCheckbox?: boolean;
    useSectionGridLayout?: boolean;
} & PropsFromRedux) => {
    if (requiresAuthentication) {
        return (
            <PaymentMethodAuthenticationModal
                authenticationIframeURL={authenticationIframeURL!}
            />
        );
    }

    return (
        // @ts-expect-error Not in TS yet
        <IwStripeProvider stripeKey={getStripePublicKey()}>
            <>
                {authenticationFailed && (
                    <div className={styles.title}>
                        <div className={styles.linkDebitCardError}>
                            <FormattedMessage
                                id="_.link_debit_card.error"
                                defaultMessage="Failed to register the card. Please try again."
                            />
                        </div>
                    </div>
                )}
                <div className={styles.LinkDebitCard}>
                    <StripeLinkDebitCardForm
                        onSuccess={onSuccess}
                        showDefaultPaymentMethodCheckbox={
                            showDefaultPaymentMethodCheckbox
                        }
                        useSectionGridLayout={useSectionGridLayout}
                    />
                </div>
            </>
        </IwStripeProvider>
    );
};

export const StripeLinkDebitCard = connect(
    mapStateToProps,
    mapDispatchToProps
)(StripeLinkDebitCardBase);
